import React from "react";
import "./terms.css";
import { Link, useNavigate } from "react-router-dom";

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="top-header">
        <div className="header-left">
          <img
            src="/assets/img/InstaTenders - Logo reduced.png"
            alt="Office logo"
            className="login-brand-logo"
          />
        </div>
      </div>

      <div className="terms-container">
        <div className="terms-banner">
          <h1>Terms & Conditions</h1>
          <p>
            <strong>Effective Date:</strong> 1st January 2026
          </p>
          <p>
            <strong>Platform Name:</strong> InstaTenders
          </p>
          <p>
            <strong>Company Name:</strong> InstaTenders Solutions Private
            Limited
          </p>
        </div>
        <div className="terms-card">
          <div className="terms-section">
            <h3>1. Introduction</h3>
            <p>
              Welcome to InstaTenders, a procurement marketplace platform that
              connects manufacturing organizations (Buyers) and Suppliers to
              streamline the procurement process. By accessing or using our
              platform, you agree to comply with and be bound by these Terms &
              Conditions.
            </p>
            <p>
              If you do not agree with these terms, please do not use our
              platform.
            </p>
          </div>

          <div className="terms-section">
            <h3>2. Definitions</h3>
            <ul>
              <li>
                <strong>Platform:</strong> Platform refers to InstaTenders
                website and mobile application.
              </li>
              <li>
                <strong>User:</strong> User refers to Buyers, Suppliers, or any
                individual accessing the platform.
              </li>
              <li>
                <strong>Buyer:</strong> Buyer refers to manufacturing
                organizations posting procurement requirements.
              </li>
              <li>
                <strong>Supplier:</strong> Supplier refers to vendors
                participating in tenders or supplying goods/services.
              </li>
              <li>
                <strong>Lead Management:</strong> Lead Management Application
                refers to the module where active procurement requirements are
                displayed.{" "}
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>3. Eligibility</h3>
            <ul>
              <li>Users must be legally registered businesses.</li>
              <li>
                Users must provide accurate company details, GST information,
                and contact details.
              </li>
              <li>
                InstaTenders reserves the right to suspend or terminate accounts
                providing false information.
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>4. User Account</h3>
            <ul>
              <li>
                Users are responsible for maintaining the confidentiality of
                login credentials.
              </li>
              <li>
                Users are responsible for all activities under their account.
              </li>
              <li>
                InstaTenders is not liable for unauthorized account access due
                to user negligence.
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>5. Platform Services</h3>
            <p>
              <strong>InstaTenders provides:</strong>
            </p>
            <ul>
              <li>Procurement requirement listing</li>
              <li>Lead management system</li>
              <li>Supplier participation system</li>
              <li>Communication facilitation between Buyers and Suppliers</li>
            </ul>

            <p>
              <strong>We do NOT:</strong>
            </p>
            <ul>
              <li>Guarantee successful transactions</li>
              <li>Guarantee payment between parties</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>6. User Responsibilities</h3>
            <p>
              <strong>Buyers:</strong>
            </p>
            <ul>
              <li>Must provide accurate procurement requirements</li>
              <li>Must respond professionally to suppliers</li>
              <li>Must comply with applicable laws and regulations</li>
            </ul>

            <p>
              <strong>Suppliers:</strong>
            </p>
            <ul>
              <li>Must provide genuine quotations and product details</li>
              <li>Must honor committed pricing and delivery terms</li>
              <li>Must comply with tax and legal obligations</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>7. Payments & Fees</h3>
            <ul>
              <li>
                InstaTenders may charge subscription fees or transaction-based
                fees.
              </li>
              <li>All payments are non-refundable unless otherwise stated.</li>
              <li>Taxes (GST) will be applicable as per Indian law.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>8. Prohibited Activities</h3>
            <p>
              <strong>Users shall not:</strong>
            </p>
            <ul>
              <li>Post false or misleading procurement requirements</li>
              <li>Engage in fraudulent transactions</li>
              <li>Use the platform for illegal activities</li>
              <li>Attempt to hack, disrupt, or misuse the platform</li>
              <li>
                Violation may result in suspension or permanent termination.
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>9. Intellectual Property</h3>
            <p>
              All platform content, design, logos, and software belong to
              InstaTenders.
            </p>
            <p>
              Users may not copy, distribute, or modify platform content without
              written permission.
            </p>
          </div>

          <div className="terms-section">
            <h3>10. Limitation of Liability</h3>
            <p>
              <strong>InstaTenders is not liable for:</strong>
            </p>
            <ul>
              <li>Disputes between Buyers and Suppliers</li>
              <li>Quality issues of goods/services</li>
              <li>Delays in delivery</li>
              <li>Financial losses arising from transactions</li>
              <li>The platform acts as a facilitator only.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>11. Termination</h3>
            <p>
              <strong>
                InstaTenders may suspend or terminate any account:
              </strong>
            </p>
            <ul>
              <li>For violation of terms</li>
              <li>For fraudulent activity</li>
              <li>For non-payment of subscription fees</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>12. Governing Law</h3>
            <p>
              These Terms shall be governed by the laws of India. Any disputes
              shall be subject to jurisdiction of courts in [Your City, State].
            </p>
          </div>

          <div className="terms-section">
            <h3>13. Changes to Terms</h3>
            <p>
              InstaTenders reserves the right to update these Terms at any time.
              Continued use of the platform constitutes acceptance of revised
              terms.
            </p>
          </div>
        </div>
      </div>
      <div className="custom-footer">
        <div className="footer-top">
          <div className="footer-col left">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms & Conditions</a>
            <a href="/refund">Refund Policy</a>
            <a href="/cancellation">Cancellation Policy</a>
          </div>

          <div className="footer-col right">
            <p>
              <span>📍</span> 4/159, Thiru.vi.ka Industrial Estate, Labour
              Colony 1st Street, Guindy, Chennai - 600032, Tamil Nadu, India
            </p>
            <p className="phone">
              <span>📞</span> +91 9884713801
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          Copyright © 2026. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Terms;